import { PackActionTypes } from "../models/packActions";
import { CHANGE_PACK_PLAN_COPY } from "../types";

export default (data: {
    planId: string,
    copyright: boolean,
}): PackActionTypes => ({
    type: CHANGE_PACK_PLAN_COPY,
    payload: data,
});
